(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('LabBundleBillingCodeDialogController', LabBundleBillingCodeDialogController);

    LabBundleBillingCodeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'LabBundleBillingCode'];

    function LabBundleBillingCodeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, LabBundleBillingCode) {
        var vm = this;

        vm.labBundleBillingCode = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.labBundleBillingCode.id !== null) {
                LabBundleBillingCode.update(vm.labBundleBillingCode, onSaveSuccess, onSaveError);
            } else {
                LabBundleBillingCode.save(vm.labBundleBillingCode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:labBundleBillingCodeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
